import { render } from "./Top5ModuleChart.vue?vue&type=template&id=9689600a"
import script from "./Top5ModuleChart.vue?vue&type=script&lang=js"
export * from "./Top5ModuleChart.vue?vue&type=script&lang=js"
script.render = render

export default script